import { render, staticRenderFns } from "./mbindex.vue?vue&type=template&id=41aade44&scoped=true&"
import script from "./mbindex.vue?vue&type=script&lang=js&"
export * from "./mbindex.vue?vue&type=script&lang=js&"
import style0 from "./mbindex.vue?vue&type=style&index=0&id=41aade44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aade44",
  null
  
)

export default component.exports